var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3.75C8.80117 3.75 6.6 5.95117 6.6 8.65C6.6 10.3371 7.46133 11.8355 8.76562 12.7188C6.26914 13.7906 4.5 16.268 4.5 19.15H5.9C5.9 16.0492 8.39922 13.55 11.5 13.55C14.6008 13.55 17.1 16.0492 17.1 19.15H18.5C18.5 16.268 16.7309 13.7906 14.2344 12.7188C15.5387 11.8355 16.4 10.3371 16.4 8.65C16.4 5.95117 14.1988 3.75 11.5 3.75ZM11.5 5.15C13.4414 5.15 15 6.70859 15 8.65C15 10.5914 13.4414 12.15 11.5 12.15C9.55859 12.15 8 10.5914 8 8.65C8 6.70859 9.55859 5.15 11.5 5.15Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.1f5b1c2b05e9cb06b0ed1e784983fd47.svg";
export { ForwardRef as ReactComponent };